import { Col, Empty, Row, Typography } from "antd";
import React from "react";
import CardDescription from "../CardDescription";
import CardMenu from "../CardMenu";
import CardTitle from "../CardTitle";
import StyledSelect from "../StyledSelect";
import BarChartPercepciones from "../../misc/barChartPercepciones";
import CenterSpin from "../../misc/spin";
import "../Card.css";
import DownloadButton from "../DownloadButton";

const { Paragraph } = Typography;

/**
 *
 * @param {Object} countryProps Object with props collected from COUNTRY_OPTIONS for the needed country
 * @param {Boolean} isLoading Boolean to know if graph data is finished loading
 * @param {Boolean} isDataAvailable Boolean to know if data was returned from backend
 * @param {string} cardTitle String with title of card used for headging
 * @param {string} methodolgy String or JSX for methodology tooltip
 * @param {string} descripiton String or JSX for description text
 * @param {array} selectArray Array containing the selectors for the menu
 * @param {string} language en/es
 * @param {string} currentGraphType
 * @param {array} tableData
 *
 * @returns {JSX} JSX -- Complete Card component contents
 */
export default function CardPercepciones({
  countryProps,
  isDataLoading,
  isDataAvailable,
  cardTitle,
  cardSource,
  methodology,
  description,
  selectArray,
  questionSelect,
  multipleSelectArray,
  language,
  currentGraphType,
  tableData,
  downloadableCardID,
  downloadableCardFileName,
  downloadableCardTitle,
  downloadableCardSubtitle,
}) {
  return (
    <Row style={{ height: "100%" }}>
      <Col xs={24} lg={8} style={{ height: "100%" }}>
        <CardMenu>
          <div>
            <CardTitle
              title={cardTitle}
              methodology={methodology}
              language={language}
            />
            <CardDescription text={description} />
            <br/>
            {selectArray.map((select, key) => {
              return (
                <StyledSelect
                  key={key}
                  selectedValue={select.selectedValue}
                  changeHandler={select.changeHandler}
                  options={select.options}
                  placeHolderText={select.placeHolderText}
                  labelAttributeName={select.labelAttributeName}
                  valueAttributeName={select.valueAttributeName}
                  ignoreTranslation={select.ignoreTranslation}
                  language={language}
                  isDisabled={select.isDisabled}
                />
              );
            })}
            {/* {multipleSelectArray.map((select, key) => {
            return (
              <MultipleStyledSelect
                key={key}
                options={select.options}
                selectedOptions={select.selectedOptions}
                changeHandler={select.changeHandler}
                handleClear={select.handleClear}
                isDisabled={select.isDisabled}
                placeholderText={select.placeHolderText}
                defaultValue={select.defaultValue}
                labelAttributeName={select.labelAttributeName}
                valueAttributeName={select.valueAttributeName}
                language={language}
              />
            );
          })} */}
            <div
              style={{
                fontSize: "12px",
              }}
              className="hidden-large-screen"
            >
              <StyledSelect
                selectedValue={questionSelect.selectedValue}
                changeHandler={questionSelect.changeHandler}
                options={questionSelect.options}
                placeHolderText={questionSelect.placeHolderText}
                labelAttributeName={questionSelect.labelAttributeName}
                valueAttributeName={questionSelect.valueAttributeName}
                ignoreTranslation={questionSelect.ignoreTranslation}
                language={language}
                isDisabled={questionSelect.isDisabled}
              />
            </div>
          </div>

          <DownloadButton
            id={downloadableCardID}
            fileName={downloadableCardFileName}
            title={downloadableCardTitle}
            subtitle={downloadableCardSubtitle}
            language={language}
            isSurveyCard={true}
          />
        </CardMenu>
      </Col>
      <Col xs={24} lg={16}>
        <div className="card-content-percepciones">
          <div
            style={{
              fontSize: "12px",
            }}
            className="hidden-small-screen"
          >
            <StyledSelect
              selectedValue={questionSelect.selectedValue}
              changeHandler={questionSelect.changeHandler}
              options={questionSelect.options}
              placeHolderText={questionSelect.placeHolderText}
              labelAttributeName={questionSelect.labelAttributeName}
              valueAttributeName={questionSelect.valueAttributeName}
              ignoreTranslation={questionSelect.ignoreTranslation}
              language={language}
              isDisabled={questionSelect.isDisabled}
            />
          </div>

          {isDataLoading ? (
            <CenterSpin />
          ) : !isDataAvailable ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexGrow: 1,
              }}
            >
              <Empty
                style={{ width: "100%" }}
                description={
                  <span style={{ fontSize: "24px" }}>
                    Sin datos para {countryProps.country_text}
                  </span>
                }
              />
            </div>
          ) : (
            <BarChartPercepciones
              type={currentGraphType}
              data={tableData}
              language={language}
            />
          )}
          <Paragraph
            className="gbi"
            style={{
              fontSize: "10px",
              marginBottom: "0px",
              textAlign: "end",
            }}
          >
            {cardSource}
          </Paragraph>
        </div>
      </Col>
      <div id={downloadableCardID + "-dc"}></div>
    </Row>
  );
}
